type IframeMessageType = "iframe_close" | "token_refresh_request";

interface IframeMessage {
  type: IframeMessageType;
  payload?: Record<string, unknown>;
}

export interface IframeTokenResponse {
  token: string;
  refresh_token: string;
  refresh_exp: number;
}

export const isIframeBridgeAvailable = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export const postIframeMessage = (
  type: IframeMessageType,
  payload?: Record<string, unknown>,
): void => {
  const message: IframeMessage = { type, ...(payload && { payload }) };
  window.parent.postMessage(JSON.stringify(message), "*");
};

export const waitForIframeMessage = <T>(
  expectedType: string,
  timeoutMs: number,
): Promise<T> => {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => {
      window.removeEventListener("message", handler);
      reject(new Error(`Timeout waiting for message: ${expectedType}`));
    }, timeoutMs);

    const handler = (event: MessageEvent) => {
      try {
        const data =
          typeof event.data === "string" ? JSON.parse(event.data) : event.data;

        if (data?.type === expectedType) {
          clearTimeout(timer);
          window.removeEventListener("message", handler);
          resolve(data.payload as T);
        }
      } catch {
        // Ignore non-JSON messages
      }
    };

    window.addEventListener("message", handler);
  });
};
